import React from "react";

type CustomMessageProps = {
  severity: 'error' | 'warn' | 'success' | 'info' ;
  text: string | React.ReactNode;
  icon?: string;
};

const CustomMessage: React.FC<CustomMessageProps> = (props) => {
  const icons: any = {
    'error': 'pi pi-times-circle',
    'warn': 'pi pi-exclamation-triangle',
    'success': 'pi pi-check',
    'info': 'pi pi-info-circle'
  }

  return (
    <div className={`p-message p-component p-message-${props.severity} p-message-enter-done`}>
      <div className="p-message-wrapper">
        {props.icon ? <span className={`p-message-icon pi pi-times-circle`} /> : <span className={`p-message-icon ${icons[props.severity]}`} />}
        
        <span className="p-message-summary">
          {props.text}
        </span>
        <span className="p-message-detail" />
      </div>
    </div>
  );
}

export { CustomMessage }